class AlreadyInLeagueError extends Error {
    constructor(m?: string) {
        super(m);
    }
}

export default AlreadyInLeagueError;
